module.exports = __webpack_public_path__ + "img/about_img_02.cc8d4066.jpg";